import { WebsiteItem } from '@/types'
import { BaseHttpService } from './base-http-service'

class PriceService extends BaseHttpService {
    async getPrice(item: WebsiteItem) {
        const params = new URLSearchParams()
        Object.entries(item).forEach(([key,value]) => params.append(key, value as string))

        const result = await this.doApiGet(`/price?${params.toString()}`)
        return result?.response
    }
}

export default new PriceService()